import { useCallback, useEffect, useState } from 'react';
import { gridChannelWidth, isTvDayTodayCET, livePositionOfToday } from './tv-guide-types';
const updateIntervalInSeconds = 15;
export const useNowMarkerPosition = (date, widthPerMinute, offset = gridChannelWidth) => {
  const [now, setNow] = useState(undefined);
  const updateNow = useCallback(() => {
    if (isTvDayTodayCET(date)) {
      setNow(livePositionOfToday(widthPerMinute, offset));
    } else {
      setNow(undefined);
    }
  }, [widthPerMinute, date, offset]);
  useEffect(() => {
    updateNow();
    const intervalId = setInterval(updateNow, updateIntervalInSeconds * 1000);
    return () => clearInterval(intervalId);
  }, [updateNow]);
  return now;
};